import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { GridRow, GridColumn, Select } from "arv-reactcomponents";

import BrandListSearch from "../BrandListSearch";

@inject("CommonStore")
@observer
class BrandListFilter extends Component {
  static returnFilterList(filter) {
    return (
      <li className="nw-brandslist-filterlist" key={filter}>
        {filter}
      </li>
    );
  }

  constructor(props) {
    super(props);

    this.getSelectSelection = this.getSelectSelection.bind(this);
    this.updateQuery = this.updateQuery.bind(this);
    this.handleInputQuerySubmit = this.handleInputQuerySubmit.bind(this);
  }

  getSelectSelection(selectedValue) {
    this.props.setSelectedValue(selectedValue);
  }

  updateQuery(value) {
    this.props.handleInputQuery(value);
  }

  handleInputQuerySubmit(value) {
    this.props.handleInputQuerySubmit(value);
  }

  get filterComponent() {
    const {
      filters,
      showBrandTypeFilter,
      selectSelectedValue,
      selectClassName,
      query,
      gridClassName,
      formClassName,
      inputClassName,
      buttonClassName,
      errorClassName,
    } = this.props;

    if (!showBrandTypeFilter) {
      return (
        <GridRow>
          <GridColumn className="nwc-grid-col-sm">
            <BrandListSearch.component
              placeholder="Search Brand"
              query={query}
              formClassName={formClassName}
              inputClassName={inputClassName}
              buttonClassName={buttonClassName}
              errorClassName={errorClassName}
              handleInputQuery={this.updateQuery}
              handleInputQuerySubmit={this.handleInputQuerySubmit}
            />
          </GridColumn>
        </GridRow>
      );
    }
    return (
      <GridRow>
        <GridColumn className={`nwc-grid-col-sm ${gridClassName}`}>
          <Select
            className={`nwc-select nwc-inp-dark-background ${selectClassName}`}
            selectedValue={selectSelectedValue}
            inpList={filters}
            getSelection={this.getSelectSelection}
            renderList={BrandListFilter.returnFilterList}
          />
        </GridColumn>
        <GridColumn className="nwc-grid-col-sm">
          <BrandListSearch.component
            placeholder="Search Brand"
            query={query}
            formClassName={formClassName}
            inputClassName={inputClassName}
            buttonClassName={buttonClassName}
            errorClassName={errorClassName}
            handleInputQuery={this.updateQuery}
            handleInputQuerySubmit={this.handleInputQuerySubmit}
          />
        </GridColumn>
      </GridRow>
    );
  }

  render() {
    const { filters } = this.props;
    const { isDesktop } = this.props.CommonStore;
    return isDesktop && filters && filters.length > 0
      ? this.filterComponent
      : null;
  }
}

BrandListFilter.wrappedComponent.propTypes = {
  filters: PropTypes.arrayOf().isRequired,
  selectSelectedValue: PropTypes.string.isRequired,
  selectClassName: PropTypes.string.isRequired,
  setSelectedValue: PropTypes.func.isRequired,
  gridClassName: PropTypes.string.isRequired,
  formClassName: PropTypes.string.isRequired,
  inputClassName: PropTypes.string.isRequired,
  buttonClassName: PropTypes.string.isRequired,
  errorClassName: PropTypes.string.isRequired,
  query: PropTypes.string.isRequired,
  handleInputQuery: PropTypes.func.isRequired,
  handleInputQuerySubmit: PropTypes.func.isRequired,
  showBrandTypeFilter: PropTypes.bool.isRequired,
};

const getFinalComponent = component =>
  inject("CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: BrandListFilter.wrappedComponent,
  component: BrandListFilter,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/BrandsList/BrandListFilter/index.js